import TableWidget from "../../../components/tables/TableWidget";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { fetchCommandHistory } from "../../../redux/api/picking.api";
import { TableActions } from "../../../components/tables/tableContext/TableContext";

import {
  commandHistoryTableHeader,
  getCommandHistoryTableData,
} from "./components/tableConfigs/commandHistoryTableConfig";

function CommandHistory() {
  const dispatch = useAppDispatch();
  const {
    picking: {
      commandHistory: {
        data: { total, data: commandHistoryData },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    picking: state.picking,
  }));

  const handleTableActions = (action: TableActions) => {
    if (action.tableSearch) {
      dispatch(
        fetchCommandHistory({
          page: 1,
          per_page: 999,
          facturi: action.tableSearch?.facturi ?? "",
          ruta: action.tableSearch?.ruta ?? "",
          deliveryPoint: action.tableSearch?.deliveryPoint ?? "",
          commandNumber: action.tableSearch?.commandNumber ?? "",
        }),
      );
    }
  };

  return (
    <TableWidget
      tableTitle={"Istoric comanda"}
      tableHeaderData={commandHistoryTableHeader}
      tableItemsData={getCommandHistoryTableData(commandHistoryData)}
      totalItems={total}
      borderedRow
      tableLoading={isLoading}
      handleTableActions={handleTableActions}
      withTablePagination={false}
    />
  );
}

export default CommandHistory;
